module.exports = __webpack_public_path__ + "img/particulares_pago_por_link.da283da2.svg";